import { Routes } from '@angular/router';
import { authGuard } from './Modules/Shared/Guards/auth.guard';
import { onboardingCompletedGuard } from './Modules/Shared/Guards/onboarding-completed.guard';
import { customOfferLinkGuard } from './Modules/Shared/Guards/custom-offer-link.guard';
import { planSelectionGuard } from './Modules/Shared/Guards/plan-selection.guard';
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'offer/:token',
    canActivate: [customOfferLinkGuard],
    children: [],
  },
  {
    path: '',
    loadComponent: () =>
      import('./Modules/Auth/Components/auth-shell/auth-shell.component').then(
        (m) => m.AuthShellComponent,
      ),
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./Modules/Auth/Components/Pages/login/login.component').then(
            (m) => m.LoginComponent,
          ),
      },
      {
        path: 'auth/callback',
        loadComponent: () =>
          import('./Modules/Auth/Components/Pages/callback/callback.component').then(
            (m) => m.CallbackComponent,
          ),
      },
    ],
  },
  {
    path: 'setup',
    loadComponent: () =>
      import('./Modules/Setup/Components/setup-container/setup-container.component').then(
        (m) => m.SetupContainerComponent,
      ),
    canActivate: [authGuard, onboardingCompletedGuard],
    children: [
      {
        path: 'company-setup',
        loadComponent: () =>
          import('./Modules/Setup/Components/Pages/company-setup/company-setup.component').then(
            (m) => m.CompanySetupComponent,
          ),
      },
      {
        path: 'plan-selection',
        canActivate: [planSelectionGuard],
        loadComponent: () =>
          import('./Modules/Setup/Components/Pages/plan-selection/plan-selection.component').then(
            (m) => m.PlanSelectionComponent,
          ),
      },
      {
        path: 'admin-consent',
        loadComponent: () =>
          import('./Modules/Setup/Components/Pages/admin-consent/admin-consent.component').then(
            (m) => m.AdminConsentComponent,
          ),
      },
      {
        path: 'configuration-choice',
        loadComponent: () =>
          import('./Modules/Setup/Components/Pages/configuration-choice/configuration-choice.component').then(
            (m) => m.ConfigurationChoiceComponent,
          ),
      },
      {
        path: 'review',
        loadComponent: () =>
          import('./Modules/Setup/Components/Pages/review/review.component').then(
            (m) => m.ReviewComponent,
          ),
      },
      { path: '', redirectTo: 'company-setup', pathMatch: 'full' },
    ],
  },
  {
    path: 'all-set',
    loadComponent: () =>
      import('./Modules/Setup/Components/Pages/all-set/all-set.component').then(
        (m) => m.AllSetComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'blocked',
    loadComponent: () =>
      import('./Modules/Setup/Components/Pages/blocked/blocked.component').then(
        (m) => m.BlockedComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'colleague-completed',
    loadComponent: () =>
      import('./Modules/Setup/Components/Pages/colleague-completed/colleague-completed.component').then(
        (m) => m.ColleagueCompletedComponent,
      ),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
